import React from 'react';
import { Wrapper } from './styled';
import { currentYear } from '@app/src/utils/validations';

interface Props {
    refFooter?: any;
}

export const MiniFooter: React.FC<Props> = ({ refFooter }) => (
    <Wrapper ref={refFooter}>
        © {currentYear()} Clasificados
    </Wrapper>
);